import React, { Component } from 'react'
import { connect } from 'react-redux'
import { extendStay, checkOut } from '../../action/viewBillAction'
import { popupOpenClose, setLoadingMass } from '../../action/action'
import { viewBIllColorConfig } from '../../JS/setColors'

class ShowBill extends Component {

    componentDidMount() {
        viewBIllColorConfig(this.props.menuColor);
    }
    extendStay = () => {
        console.log("extend stay called", this.props.extendStayID)

        if (this.props.extendStayID) {
            this.props.extendStay(this.props.selectedGuest, this.props.extendStayID, this.onSuccess, this.onFailure);
        }
        this.props.setLoadingMass(true);
    }
    onSuccess = (msg) => {
        this.props.setLoadingMass(false);
        this.props.popupOpenClose(true, msg);
    }
    onFailure = (msg) => {
        this.props.setLoadingMass(false);
        this.props.popupOpenClose(true, msg);
    }

    checkOut = () => {
        console.log("checkout called")
        this.props.checkOut(this.props.selectedGuest, this.props.billTotal, this.onSuccess, this.onFailure);
        this.props.setLoadingMass(true);
    }
    render() {
        return (
            <div id="vb-list" class="col col-2 h-100 results-col"
                style={{ background: "rgba(204,204,204,0.95)", padding: "1rem" }}>
                <div class="form-item" style={{ color: "inherit" }}>
                    <label style={{ fontStyle: "italic", color: "inherit" }}>Estimated summary of costs as of {this.props.checkInDate}</label>
                </div>
                <div class="form-item" style={{ maxHeight: "20rem", overflow: "scroll", color: "inherit" }}>
                    <label style={{ color: "inherit" }}>Charges</label>
                    <table style={{ color: "inherit" }}>
                        <thead style={{ color: "inherit" }}>
                            <tr style={{ color: "inherit" }}>
                                <th style={{ color: "inherit" }}>Description</th>
                                <th style={{ color: "inherit" }} class="w-25">Charges</th>
                            </tr>
                            {
                                this.props.billItems.map((iterator) => {
                                    return (
                                        <tr style={{ color: "inherit" }}>
                                            <td style={{ color: "inherit" }}>{iterator.itemDesc}</td>
                                            <td style={{ color: "inherit" }}>
                                                {`${this.props.currencyCode} ${
                                                    Math.ceil(iterator.itemAmount) > iterator.itemAmount && Math.floor(iterator.itemAmount) < iterator.itemAmount
                                                        ? iterator.itemAmount.toFixed(2) : iterator.itemAmount
                                                    }`}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            <tr style={{ color: "inherit" }} class="totals">
                                <td style={{ color: "inherit" }}>
                                    <strong style={{ color: "inherit" }}>Total</strong>
                                </td>
                                <td style={{ color: "inherit" }}>
                                    <strong style={{ color: "inherit" }}>
                                        {`${this.props.currencyCode} ${
                                            Math.ceil(this.props.billTotal) > this.props.billTotal && Math.floor(this.props.billTotal) < this.props.billTotal
                                                ? this.props.billTotal.toFixed(2) : this.props.billTotal
                                            }`}
                                    </strong>
                                </td>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="center">
                    {/* <div class="err-msg">Insert error message here</div>
                        <div class="success-msg">Insert success message here</div> */}
                    <button id="viewBillExpressCheckOut" class="button w-45" onClick={this.checkOut}>Express check-out</button>
                    <button id="viewBillExtendStay" class="button w-45" style={{ marginLeft: "5px" }} onClick={this.extendStay}>Extend Stay</button>
                </div>
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetails: state.store.home.guestDetails,
        CheckedInGuest: state.store.CheckedInGuest,
        currentWidget: state.store.sideNavBar.currentWidget,
        billItems: state.store.viewBill.billItems,
        menuColor: state.store.home.MenuColor,
        billTotal: state.store.viewBill.billTotal,
        extendStayID: state.store.viewBill.extendStayID,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
        state.store.home.clientConfig.currencyDetails.code : ""
    }
}

export default connect(
    mapStateToProps,
    {
        extendStay,
        checkOut,
        popupOpenClose,
        setLoadingMass
    }
)(ShowBill);